import React from "react";
import {
  Typography,
  Flex,
  FabButton,
  Row,
  Col,
  Box,
  Avatar,
  Button,
  Icon
} from "../../../ppui";
import { Card, CardHeading, OrganizationBx, OrganizationEmDetails } from "../../style";
import { TbBuilding, TbBuildingBank, TbCalendarEvent, TbFileBarcode, TbFileDiff, TbFileDownload, TbFileInvoice, TbFileText, TbPencil, TbUserCheck, TbUserPlus, TbUserShield } from "react-icons/tb";

import { formatToDDMMYYYY } from "../../../utils/common";
import EsciUpdateModal from "./modals/esci-update-modal";
import EpfupdateModal from "./modals/epf-update-modal";
import BankUpdateModal from "./modals/bank-update-modal";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import KycUpdateModal from "./modals/kyc-update-modal";


const StatutoryKycView = ({
  orginfo,
  orginfoESCI,
  fileInputRef,
  EmployeeESCI,
  onChnageESCI,
  OnBlureESCI,
  ToggleEsci,
  errorsESCI,
  EmployeeEPF,
  onChanageEPF,
  OnBlureEPF,
  ToggleEPF,
  errorsEPF,
  bankdetails,
  onChangeBank,
  // OnBlureBank,
  errorBank,
  handleButtonClick,
  handleFileChange,
  docs,
  alldocs,
  checkDocName,
  DeleteSpecificFile,
  onChangeKYCdoc,
  openFileInNewTab,
  UpdateStatutory,
  employeeInfo,
  escimodal, TogggleEsciMOdal, epfmodal,
  TogggleEpfMOdal,
  bankmodal,
  ToggleBank,
  kycModal,
  ToggleKycModal,
  updateLoder
}) => {

  return (
    <>
      <Card>
      <CardHeading Divider>
        Employee Under ESI Scheme
        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={TogggleEsciMOdal}
          variant="filled"
          shape="box"
        />
      </CardHeading>
      <OrganizationEmDetails>
        <OrganizationBx>
          <Icon size={"lg"}>
            <TbFileText /> {/* Suitable for Insurance Number */}
          </Icon>
          <Box>
            <Typography variant="body1" mb={"0"} color="primary">
              Insurance No
            </Typography>
            <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
              {employeeInfo?.esic_insurance_number || "--"}
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbCalendarEvent /> {/* Suitable for Registration Date */}
          </Icon>
          <Box>
            <Typography variant="body1" mb={"0"} color="primary">
              Registration Date
            </Typography>
            <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
              {employeeInfo?.esic_registration_date
                ? formatToDDMMYYYY(new Date(employeeInfo?.esic_registration_date))
                : "--"}
            </Typography>
          </Box>
        </OrganizationBx>

        <OrganizationBx>
          <Icon size={"lg"}>
            <TbFileDownload /> {/* Suitable for Attachment */}
          </Icon>
          <Box>
            <Typography variant="body1" mb={"0"} color="primary">
              Attachment
            </Typography>
            <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
              {employeeInfo?.esic_card_attachment ? (
                <span
                  onClick={() => window.open(employeeInfo?.esic_card_attachment, "_blank")}
                  style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }} // Make it look like a link
                >
                  View / Download File
                </span>
              ) : (
                "--"
              )}
            </Typography>
          </Box>
        </OrganizationBx>
      </OrganizationEmDetails>
    </Card>


     
      <Card>
        <CardHeading Divider>
          Employee Under EPF Scheme
          <FabButton
            size="sm"
            icon={<TbPencil />}
            onClick={TogggleEpfMOdal}
            variant="filled"
            shape="box"
          />
        </CardHeading>
        <OrganizationEmDetails>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbUserCheck /> {/* Suitable for Member Payroll */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Member Payroll
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.member_payroll ? "Yes" : "No"}
              </Typography>
            </Box>
          </OrganizationBx>

          {employeeInfo?.member_payroll && (
            <OrganizationBx>
              <Icon size={"lg"}>
                <TbFileText /> {/* Suitable for EPF ID Account Number */}
              </Icon>
              <Box>
                <Typography variant="body1" mb={"0"} color="primary">
                  EPF Id Account Number
                </Typography>
                <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                  {employeeInfo?.epf_id_ac_no || "N/A"}
                </Typography>
              </Box>
            </OrganizationBx>
          )}

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileInvoice /> {/* Suitable for UAN */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                UAN
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.uan_no || "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbUserPlus /> {/* Suitable for Employee Contribution */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Employee Contribution
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.employee_contribution === null
                  ? "N/A"
                  : employeeInfo?.employee_contribution === "restrict_contribution"
                  ? "Restrict Contribution to ₹1500 of PF Wages"
                  : "Unrestricted Contribution (Based on Actual Wages)"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbUserShield /> {/* Suitable for Retired Govt. Employee */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Retired Govt. Employee
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.retired_govt_employee ? "Yes" : "No"}
              </Typography>
            </Box>
          </OrganizationBx>

          {employeeInfo?.retired_govt_employee && (
            <OrganizationBx>
              <Icon size={"lg"}>
                <TbFileText /> {/* Suitable for PPO. No */}
              </Icon>
              <Box>
                <Typography variant="body1" mb={"0"} color="primary">
                  PPO. No
                </Typography>
                <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                  {employeeInfo?.ppo_no || "N/A"}
                </Typography>
              </Box>
            </OrganizationBx>
          )}

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbCalendarEvent /> {/* Suitable for Registration Date */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Registration Date
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.epf_registration_date === null
                  ? "N/A"
                  : formatToDDMMYYYY(new Date(employeeInfo?.epf_registration_date))}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileDownload /> {/* Suitable for Attachment */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Attachment
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.epf_uan_attachment ? (
                  <span
                    onClick={() => window.open(employeeInfo?.epf_uan_attachment, "_blank")}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    View / Download File
                  </span>
                ) : (
                  "N/A"
                )}
              </Typography>
            </Box>
          </OrganizationBx>
        </OrganizationEmDetails>
      </Card>

      <Card>
        <CardHeading Divider>Bank Details

          <FabButton
            size="sm"
            icon={<TbPencil />}
            onClick={ToggleBank}
            variant="filled"
            shape="box"
          />
        </CardHeading>
        <OrganizationEmDetails>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbBuildingBank /> {/* Suitable for Bank Name */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Bank Name
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.bank_name || "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbBuilding /> {/* Suitable for Branch Name */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Branch Name
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.branch_name || "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileText /> {/* Suitable for Account Number */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Account Number
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.account_number || "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileBarcode /> {/* Suitable for IFSC Code */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                IFSC Code
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.ifsc_code || "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbFileBarcode /> {/* Suitable for IFSC Code */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Payment Through
              </Typography>
              <Typography variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize">
                {employeeInfo?.payment_through || "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>
        </OrganizationEmDetails>
      </Card>
      <Card>
        <CardHeading Divider>
          KYC Document
          <Button
            size="sm"
            icon={<TbFileDiff />            }
            onClick={ToggleKycModal}
            variant="contained"
            color="primary"
          >Add New</Button>
        </CardHeading>
        <Flex direction="column" gap={30}>
        {employeeInfo?.kyc_additional_info?.map((item, index) => (
            <Row rowGap key={index}>
              <Col sm={12} md={4} lg={8}>
                <Flex gap={20}>
                  <Box>
                    <Avatar shape="square" icon={<BsFileEarmarkPdfFill />} />
                  </Box>
                  <Box>
                    <Typography variant="body2" mb={"0"} color={"dark"}>
                      {item?.document_type}
                    </Typography>
                    <Typography variant="h5" mb={"0"}>
                      {item?.document_number}
                    </Typography>
                  </Box>
                </Flex>
              </Col>

              <Col sm={12} md={4} lg={4} xl={3} xxl={2}>
                <Flex gap={10}>


                  <Button
                    onClick={() => window?.open(item?.attachment, "_blank")}
                    variant="filled"
                    size="sm"
                    color="primary"
                  >
                    View
                  </Button>
                </Flex>
              </Col>
            </Row>
          ))
          }


        </Flex>
        {employeeInfo?.kyc_additional_info.length === 0 && (
          <>
        <Flex alignItem="center">
        <Typography variant="body2" mb={"0"}>Please Add KYC Details for better visibility.</Typography>
        <Button color="secondary" size="sm" onClick={ToggleKycModal}>Click here</Button> 
        </Flex>
          </>
      )}
       </Card>    
     
      <EsciUpdateModal
        EmployeeESCI={EmployeeESCI}
        escimodal={escimodal}
        TogggleEsciMOdal={TogggleEsciMOdal}
        orginfoESCI={orginfoESCI}
        onChnageESCI={onChnageESCI}
        OnBlureESCI={OnBlureESCI}
        ToggleEsci={ToggleEsci}
        errorsESCI={errorsESCI}
        UpdateStatutory={UpdateStatutory}
        updateLoder={updateLoder}
      />
      <EpfupdateModal
        EmployeeEPF={EmployeeEPF}
        epfmodal={epfmodal}
        onChanageEPF={onChanageEPF}
        OnBlureEPF={OnBlureEPF}
        ToggleEPF={ToggleEPF}
        errorsEPF={errorsEPF}
        orginfo={orginfo}
        TogggleEpfMOdal={TogggleEpfMOdal}
        UpdateStatutory={UpdateStatutory}
        updateLoder={updateLoder}
      />
      <BankUpdateModal
        bankmodal={bankmodal}
        ToggleBank={ToggleBank}
        UpdateStatutory={UpdateStatutory}
        bankdetails={bankdetails}
        onChangeBank={onChangeBank}
        // OnBlureBank={OnBlureBank}
        errorBank={errorBank}
        updateLoder={updateLoder}
      />
      <KycUpdateModal
        kycModal={kycModal}
        ToggleKycModal={ToggleKycModal}
        UpdateStatutory={UpdateStatutory}
        alldocs={alldocs}
        onChangeKYCdoc={onChangeKYCdoc}
        checkDocName={checkDocName}
        DeleteSpecificFile={DeleteSpecificFile}
        docs={docs}
        handleButtonClick={handleButtonClick}
        handleFileChange={handleFileChange}
        openFileInNewTab={openFileInNewTab}
        fileInputRef={fileInputRef}
        updateLoder={updateLoder}
      />
    </>
  )
}

export default StatutoryKycView